module.exports = __webpack_public_path__ + "static/media/10a.7a429f3a.jpeg";